import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function CertificatesPage() {
  return <InstituteCrudPage config={entityConfigs['certificates']} />;
}
